import styled from "styled-components";
import narrow from "../../assets/images/narrow.svg";
import expand from "../../assets/images/expand.svg";

export const ExpandIcon = styled.div`
  background-image: url(${({ fullscreen }) => (fullscreen ? narrow : expand)});
  cursor: pointer;
  height: 32px;
  margin-left: 32px;
  width: 32px;

  &:hover {
    background-image: url(${({ fullscreen }) => (fullscreen ? expand : narrow)});
  }
`;

export const Hover = styled.span`
  position: relative;
  background: ${({ theme }) => theme.colors.color18};
  border: 2px solid ${({ theme }) => theme.colors.color18};
  border-radius: 3px;
  margin: 35px;
  color: ${({ theme }) => theme.colors.color21};
  white-space: pre;
  width: 130px;
  font-size: 18px;
  font-weight: 700;
  visibility: hidden;
  opacity: 0;
  transition: opacity 1s;
  left: -110px;
  top: 50px;
  z-index: 300;

  ${ExpandIcon}:hover & {
    visibility: visible;
    opacity: 1;
  }

  &:after {
    border: solid 8px rgba(136, 183, 213, 0);
    border-bottom-color: ${({ theme }) => theme.colors.color18};
    bottom: 100%;
    content: " ";
    height: 0;
    left: 75%;
    margin-top: -8px;
    pointer-events: none;
    position: absolute;
  }
`;
